import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";
import { ReactComponent as Userimg } from "../../Assets/svg/profile-tick.svg";
import Title from "../Title/Title";
import { ReactComponent as responsiveMenu } from "../../Assets/svg/responsivemenu.svg";
import "../Title/Title.scss";
import ModalUploadPic from "../../Pages/MainPage/Dashboard/ModalUploadPic";
import axios from "axios";

const Header = (props) => {
  const { title, hasLogOut, open, setOpen } = props;
  const [date, setDate] = useState("");
  // const [open, setOpen] = useOutletContext();
  const [isOpen, setIsOpen] = useState(false);
  const [src, setSrc] = useState(localStorage.getItem("picture"));
  const navigateTo = useNavigate();
  const [userName, setUserName] = useState("");
  useEffect(() => {
    var today = new Date();

    var year = today.getFullYear();
    var month = today.getMonth();
    var date = today.getDate();

    var d = new Date(year, month, date);

    let dayForPut = new Intl.DateTimeFormat("fa-IR", {
      weekday: "short",
    }).format(d);
    const faDate = new Intl.DateTimeFormat("fa", {
      month: "long",
      day: "numeric",
      year: "numeric",
    }).format(d);
    setDate(dayForPut + "  " + faDate);
  }, []);
  useEffect(() => {
    axios({
      method: "GET",
      url: `${localStorage.getItem("apiUrl")}/lastUpdate/`,

      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((response) => {
      setUserName(response.data.KMO);
    });
  }, []);
  const user = localStorage.getItem("userName");

  return (
    <div
      className={
        "fixheader d-flex flex-wrap align-items-center justify-content-between"
      }
    >
      {isOpen && (
        <ModalUploadPic
          isOpen={isOpen}
          modalCallback={(e) => setIsOpen(e.isOpen)}
          src={src}
          setSrc={setSrc}
          setIsOpen={setIsOpen}
        />
      )}
      <div>
        <div className="res-menu" open={open} onClick={() => setOpen(!open)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M21 7.75H3C2.59 7.75 2.25 7.41 2.25 7C2.25 6.59 2.59 6.25 3 6.25H21C21.41 6.25 21.75 6.59 21.75 7C21.75 7.41 21.41 7.75 21 7.75Z"
              fill="#484848"
            />
            <path
              d="M21 12.75H3C2.59 12.75 2.25 12.41 2.25 12C2.25 11.59 2.59 11.25 3 11.25H21C21.41 11.25 21.75 11.59 21.75 12C21.75 12.41 21.41 12.75 21 12.75Z"
              fill="#484848"
            />
            <path
              d="M21 17.75H3C2.59 17.75 2.25 17.41 2.25 17C2.25 16.59 2.59 16.25 3 16.25H21C21.41 16.25 21.75 16.59 21.75 17C21.75 17.41 21.41 17.75 21 17.75Z"
              fill="#484848"
            />
          </svg>
        </div>
        <Title title={title} />
      </div>
      <div className="date">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M10 0C4.49 0 0 4.49 0 10C0 15.51 4.49 20 10 20C15.51 20 20 15.51 20 10C20 4.49 15.51 0 10 0ZM14.35 13.57C14.21 13.81 13.96 13.94 13.7 13.94C13.57 13.94 13.44 13.91 13.32 13.83L10.22 11.98C9.45 11.52 8.88 10.51 8.88 9.62V5.52C8.88 5.11 9.22 4.77 9.63 4.77C10.04 4.77 10.38 5.11 10.38 5.52V9.62C10.38 9.98 10.68 10.51 10.99 10.69L14.09 12.54C14.45 12.75 14.57 13.21 14.35 13.57Z"
            fill="#F3A002"
          />
        </svg>
        {date}
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        {userName && <li className="nav-item username px-2">{userName}</li>}
        <li className="nav-item">

          {(hasLogOut === undefined || hasLogOut !== false) && (
            <div className="nav-link user-img" onClick={() => setIsOpen(true)}>
              {!src ? <Userimg /> : <img src={src} alt="" />}
            </div>
          )}
        </li>
        <span className="back" onClick={() => navigateTo(-1)}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M14.9993 20.67C14.8093 20.67 14.6193 20.6 14.4693 20.45L7.9493 13.93C6.8893 12.87 6.8893 11.13 7.9493 10.07L14.4693 3.55002C14.7593 3.26002 15.2393 3.26002 15.5293 3.55002C15.8193 3.84002 15.8193 4.32002 15.5293 4.61002L9.0093 11.13C8.5293 11.61 8.5293 12.39 9.0093 12.87L15.5293 19.39C15.8193 19.68 15.8193 20.16 15.5293 20.45C15.3793 20.59 15.1893 20.67 14.9993 20.67Z"
              fill="#292D32"
            />
          </svg>
        </span>
      </div>
    </div>
  );
};

export default Header;
